import { render, staticRenderFns } from "./StallionPlanCuveListe.vue?vue&type=template&id=64be3dc1&"
import script from "./StallionPlanCuveListe.vue?vue&type=script&lang=js&"
export * from "./StallionPlanCuveListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports